import { render, staticRenderFns } from "./SchemeCreate.vue?vue&type=template&id=70729124&"
import script from "./SchemeCreate.vue?vue&type=script&lang=js&"
export * from "./SchemeCreate.vue?vue&type=script&lang=js&"
import style0 from "./SchemeCreate.vue?vue&type=style&index=0&id=70729124&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports